/**
 * @Description 开店区域-销售额预测
 */

import { floorKeep, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import { FC, useMemo } from 'react';
import styles from './index.module.less';
import IconFont from '../../IconFont';
import cs from 'classnames';

// 时间维度 1:天 2:周 3:月 4:季 5:年
export enum TimeDimension {
  Day = 1, // 审批中
  Week,
  Month,
  Season,
  Year,
};
export const TimeDimensionMap = new Map([
  [TimeDimension.Day, '天'],
  [TimeDimension.Week, '周'],
  [TimeDimension.Month, '月'],
  [TimeDimension.Season, '季'],
  [TimeDimension.Year, '年'],
]);

const AreaSalesPredict: FC<any> = ({
  overviewData,
  isList, // 是否列表引用
}) => {
  const title = useMemo(() => {
    const { timeDimension } = overviewData || {};
    return `预测${TimeDimensionMap.get(timeDimension) || ''}营业额`;
  }, [overviewData]);

  const mountStr = (count) => {
    if (!isNotEmpty(count)) return '';
    // floorKeep转换结果是整数时不带小数，这里希望固定带一位小数所以补充使用toFixed
    return count >= 10000
      ? `${(+floorKeep(count, 10000.0, 4, 1) as number).toFixed(1)}万元`
      : `${Math.floor(count)}元`;
  };

  const value = useMemo(() => {
    const {
      salesAmountPredict, // 预测营业额
      lowSalesAmountPredict,
      upSalesAmountPredict,
    } = overviewData || {};

    // 优先展示区间，无区间值时展示具体值
    const canShowRange = isNotEmpty(lowSalesAmountPredict) && isNotEmpty(upSalesAmountPredict);
    const canShowValue = isNotEmpty(salesAmountPredict);

    return canShowRange ? `${mountStr(lowSalesAmountPredict)}-${mountStr(upSalesAmountPredict)}` : canShowValue ? mountStr(salesAmountPredict) : '';
  }, [overviewData]);

  return (
    isNotEmptyAny(overviewData) && isNotEmpty(value) ? <div className={cs(styles.salesPredict, isList && styles.listSalesPredict)}>
      <div className={styles.title}><IconFont iconHref='iconic_yuceyingyee' className={styles.icon} />{title}</div>
      <div className={styles.value}>{value}</div>
    </div> : <></>
  );
};

export default AreaSalesPredict;
